export default "__VITE_ASSET__BOvgp0M4__"